import { render, staticRenderFns } from "./shipmentRequestIndex.pug?vue&type=template&id=efc86dbc&lang=pug&"
import script from "./shipmentRequestIndex.ts?vue&type=script&lang=ts&"
export * from "./shipmentRequestIndex.ts?vue&type=script&lang=ts&"
import style0 from "./shipmentRequestIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports